import { LoadingButton } from "@mui/lab";
import { Box, Stack, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import AutoCompleteEstados from "@/components/AutoCompleteEstados";
import SelectLiquidacion from "@/components/SelectLiquidacion";
import SelectPagado from "@/components/SelectPagado";
import { useTablaCarpetaContext } from "@/components/Tablas/TablaCarpetaV2/logics/TablaCarritoProvider";
import es from 'date-fns/locale/es';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { useEffect } from "react";

type ValueOf<T> = T[keyof T];


const FiltrosUserCarpetas = () => {

    const { context: { filter, setFilter, search, loading } } = useTablaCarpetaContext();

    const handleChangeFilter = (key: keyof typeof filter, value: ValueOf<typeof filter>) => {
        setFilter({ ...filter, [key]: value, page: 1 });
    }

    useEffect(() => {
        const fechaDesde = dayjs().subtract(2, 'month').toDate();
        const fechaHasta = dayjs().toDate();
        const filters = { ...filter, fechaDesde, fechaHasta };
        setFilter(filters);
        search(filters)
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
            <Stack spacing={0} mb={5} direction="row" justifyContent="flex-start" flexWrap="wrap" rowGap={2} columnGap={2}>
                <Box display='flex' flexDirection='column'>
                    <DatePicker
                        sx={{ maxWidth: 160, mb: 2 }}
                        label="Fecha de inicio"
                        minDate={dayjs().subtract(2, 'year').toDate()}
                        maxDate={dayjs().toDate()}
                        slotProps={{ textField: { placeholder: 'Fecha de fin', size: 'small' } }}
                        value={filter.fechaDesde ?? null}
                        onChange={(date) => {
                            handleChangeFilter('fechaDesde', date ?? undefined);
                        }}
                        disableFuture
                    />
                    <DatePicker
                        sx={{ maxWidth: 160 }}
                        slotProps={{ textField: { placeholder: 'Fecha de fin', size: 'small' } }}
                        label="Fecha de fin"
                        minDate={dayjs().subtract(2, 'year').toDate()}
                        maxDate={dayjs().toDate()}
                        value={filter.fechaHasta ?? null}
                        onChange={(date) => {
                            handleChangeFilter('fechaHasta', date ?? undefined);
                        }}
                        disableFuture
                    />
                </Box>


                <AutoCompleteEstados
                    sx={{ minWidth: 180, maxWidth: 200 }}
                    label="Filtrar por estado"
                    onChange={(estado) => {
                        handleChangeFilter('estado', estado ?? undefined);
                    }}
                    value={filter.estado ?? null}
                    size="small"
                />


                <SelectLiquidacion
                    label="Filtrar por liquidación"
                    sx={{ minWidth: 180, maxWidth: 200 }}
                    onChange={(estado) => {
                        handleChangeFilter('estaLiquidado', estado);
                    }}
                    value={filter.estaLiquidado}
                    size="small"
                />

                <SelectPagado
                    label="Está pagado?"
                    sx={{ minWidth: 180, maxWidth: 200 }}
                    onChange={(estado) => {
                        handleChangeFilter('estaPago', estado);
                    }}
                    value={filter.estaPago}
                    size="small"
                />

                <TextField
                    label="Filtrar por ID de carpeta"
                    sx={{ minWidth: 180, maxWidth: 200 }}
                    size="small"
                    value={filter.carpetaId}
                    onChange={(e) => {
                        handleChangeFilter('carpetaId', e.target.value);
                    }}
                />

                <LoadingButton
                    loading={loading}
                    sx={{ minWidth: 180, maxWidth: 200 }}
                    onClick={() => search()}
                    variant="contained"
                    size="small"
                >
                    Buscar
                </LoadingButton>
            </Stack>
        </LocalizationProvider>

    );
}

export default FiltrosUserCarpetas;